import { physicsToLogic } from '../transform';
import { __setPhysics__, __setLogic__ } from './db';

export function setCoordinate(cubeId: CubeId, coordinate: PhysicsCoordinate): void {
    __setPhysics__(cubeId, coordinate);
    __setLogic__(cubeId, physicsToLogic(coordinate));
}
